import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=11aa2544&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=11aa2544&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa2544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11aa2544')) {
      api.createRecord('11aa2544', component.options)
    } else {
      api.reload('11aa2544', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=11aa2544&scoped=true", function () {
      api.rerender('11aa2544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rs/merchant/detail.vue"
export default component.exports